import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../AxiosConfig";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    handleLogout();
  }, []);

  const handleLogout = async () => {
    try {
      const loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      const userData = JSON.parse(localStorage.getItem("userData"));

      const userId =
        loginInfo?.userId ||
        userData?._id ||
        userData?.Userinfo?._id;

      const role =
        loginInfo?.roleName ||
        userData?.Userinfo?.role;

      const database = loginInfo?.database;

      const sessionId =
        loginInfo?.sessionId ||
        userData?.sessionId ||
        localStorage.getItem("sessionId");

      const now = new Date();

      const date = `${String(now.getMonth() + 1).padStart(2, "0")}/${String(
        now.getDate()
      ).padStart(2, "0")}/${now.getFullYear()}`;

      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      const logOutTime = `${hours}:${minutes}:${seconds} ${ampm}`;

      const payload = {
        userId,
        date,
        logOutTime,
        database,
        sessionId,
      };

      // ✅ API Call 1
      await axiosConfig.post("/activity/update-logOutTime", payload);
      // ✅ API Call 2
      const data = new FormData();
      data.append("user_id", userId);
      data.append("role", role);

      await axiosConfig.post("/apiLogout", data);

    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      // ✅ Always clear + redirect
      localStorage.clear();
      navigate("/login"); // 👈 Login page
    }
  };

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <h3>Logging out...</h3>
    </div>
  );
}